module.exports = __webpack_public_path__ + "images/category_lp/pc/h1_bg_0e6e573bfc6300230eda4e9c1ae3c4e0.jpg";